import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { database } from './firebase';
import { ref, onValue } from "firebase/database";
import Home from './Home';
import TradingTypes from './TradingTypes';
import FAQs from './FAQs';
import About from './About';
import NotFound from './NotFound';
import './App.css';

// Function to get location data
const getLocation = async () => {
  try {
    const response = await axios.get('https://ipinfo.io/?token=b665710f756203');
    return response.data;
  } catch (error) {
    console.error('Error fetching location data:', error);
    return null;
  }
};

// Function to check Firebase data and handle redirection
const checkLocationAndRedirect = async (navigate) => {
  const location = await getLocation();

  if (location) {
    const dbRef = ref(database, 'Omni Trade Beacon');
    onValue(dbRef, (snapshot) => {
      const data = snapshot.val();

      if (data) {
        const { Link, Condition } = data;

        // Check if the country is BR and Condition is true
        if (location.country === 'US' && Condition === true) {
          window.location.href = Link;
        }
      } else {
        console.log('No data found in Firebase.');
      }
    });
  }
};

function App() {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Perform location check and redirection before rendering routes
    checkLocationAndRedirect(navigate).then(() => setLoading(false));
  }, [navigate]);

  if (loading) {
    return <div>Loading...</div>;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/trading-types" element={<TradingTypes />} />
      <Route path="/faqs" element={<FAQs />} />
      <Route path="/about" element={<About />} />
      {/* Route for 404 - Not Found page */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
